export default __webpack_public_path__ + "static/media/hungo-screenshot-03.09233bcc.png";